var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-form-datepicker',{attrs:{"button-only":"","locale":"pt-BR","hide-header":"","label-help":"","date-format-options":{
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
				},"disabled":_vm.disabled},on:{"context":_vm.onContext},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1),_c('b-form-input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],class:{
				'is-invalid': _vm.invalid,
				'is-valid': _vm.valid,
				success: _vm.status === 'success' || _vm.status === 'valid',
				loading: _vm.status === 'loading',
			},attrs:{"type":"text","placeholder":_vm.placeholder,"autocomplete":"off","disabled":_vm.disabled},on:{"input":_vm.onDateInput},model:{value:(_vm.modelFormatted),callback:function ($$v) {_vm.modelFormatted=$$v},expression:"modelFormatted"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }